// NumericBetweenEditor.jsx

import React from 'react';

// CSS
import './NumericBetweenEditor.css';

/**
 * NumericBetweenEditor
 *
 * Renders min/max inputs for numeric "between" condition operators.
 *
 * @param {object} literalValue - Current between literal value with min/max keys.
 * @param {object} theme - Theme object used for dynamic styling.
 * @param {function} onMinChange - Updates the minimum literal value.
 * @param {function} onMaxChange - Updates the maximum literal value.
 *
 * @returns {ReactNode} The rendered between editor.
 */
const NumericBetweenEditor = React.memo(({
  literalValue,
  theme,
  onMinChange,
  onMaxChange,
}) => {

  // ----- RENDER ----- //

  return (
    <div className="automation-modal-between-group">
      <input
        className="automation-rule-input"
        style={{
          backgroundColor: theme.panel,
          borderColor: theme.backgroundMuted,
          color: theme.foreground,
        }}
        type="number"
        placeholder="Min"
        value={literalValue?.min ?? ''}
        onChange={(event) => onMinChange(event.target.value)}
      />

      <input
        className="automation-rule-input"
        style={{
          backgroundColor: theme.panel,
          borderColor: theme.backgroundMuted,
          color: theme.foreground,
        }}
        type="number"
        placeholder="Max"
        value={literalValue?.max ?? ''}
        onChange={(event) => onMaxChange(event.target.value)}
      />
    </div>
  );
});

// Dev Tools
NumericBetweenEditor.displayName = 'NumericBetweenEditor';

export default NumericBetweenEditor;
